import React,{Component} from 'react';

import './StatusBar.css';

interface Props{
    disk?: number
    tape?: number
    sent?: number
    archived?: number
}
interface State{
}


export default class StatusBar extends Component<Props,State>{
    render(){
        let props:any = this.props;
        return (
            <div className="status-bar">
                {
                    [ 'archived', 'sent', 'tape',  'disk' ].map((type:string)=>(
                        <div
                            className={`status-bar-value ${type}-data tt`}
                            style={{ width: props[type] ? `${props[type]}%` : undefined }}
                        >
                        {
                            <div className="tt-tooltip left">
                                { props[type] } %
                            </div>
                        }
                        </div>
                    ))
                }
            </div>
        );
    }

};